// Carat uplift probe helpers (the server applies the uplift to pieces). First matching rule decides;
// rules without `manual` skip manual tags.
export function upliftHit(code, list, manual = false) {
  const c = String(code || '').trim().toUpperCase();
  if (!c) return -1;
  return list.findIndex((x) => (manual ? x.manual : true) && (x.match === 'exact' ? c === x.text : c.includes(x.text)));
}
